export default __webpack_public_path__ + "static/media/empty-saved-review.966b88f2.png";